import { useMemo } from 'react';
import { useApiQueries } from '../../app/ApiClientContext';

export function useLinks(scope: 'mine' | 'all', enabled = true) {
  const $api = useApiQueries();
  // openapi-react-query's useInfiniteQuery defaults pageParam to 0 when
  // initialPageParam is undefined and always merges it into the query string,
  // which the backend parses as Unix epoch (1970-01-01) and returns nothing.
  // Seed with current time so the first page mirrors the backend's
  // default_factory=datetime.utcnow.
  const initialDateFrom = useMemo(() => new Date().toISOString(), []);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return ($api.useInfiniteQuery as any)(
    'get',
    '/api/v2/link',
    {
      params: { query: { my: scope === 'mine', limit: 50 } },
    },
    {
      enabled,
      initialPageParam: initialDateFrom,
      getNextPageParam: (last: { next_date_from?: string | null }) =>
        last.next_date_from ?? undefined,
      pageParamName: 'date_from',
    },
  );
}
